import React, { useContext, useState, useEffect } from 'react'
import CustomInput from '../../product/components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import '../Login/Login.css'

import { mapData, handleRedirectInternal } from '../../product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import AlertContext from '../../product/context/alert/alertContext'
import UserContext from '../../product/context/user/userContext'

const ForgotPassword = (props) => {
    const userContext = useContext(UserContext)
    const alertContext = useContext(AlertContext)

    const { resetPassword, responseStatus, clearResponse } = userContext

    const history = useHistory()
    const validationArray = Yup.object({
        user_token: Yup.string().required('Required'),
        password: Yup.string()
            .trim()
            .min(10, 'Minimum 10 characters')
            .required('Required!')
            .matches(
                /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/,
                'Password must contain 3 of the 4 following: Lowercase, Uppercase, Number, Symbol',
            ),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords Not Match')
            .required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            project: 'NPS',
            user_token: props.match.params.token,
            password: '',
            confirm_password: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            resetPassword(values)
        },
    })

    const resetPasswordData = [
        {
            label: 'New Password',
            name: 'password',
            type: 'password',
            placeholder: 'Enter Your New Password',
            class: 'col-md-12',
            formik: formik,
        },
        {
            label: 'Confirm Password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re-Enter Your Password',
            class: 'col-md-12',
            formik: formik,
        },
    ]

    console.log('formik', formik.values)
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'resetPassword') {
                if (responseStatus.status === 'success') {
                    handleRedirectInternal(history, '')
                }
            }
        }
    }, [responseStatus])

    return (
        <div className="login resetPassword">
            <div className="container">
                <div className="d-flex justify-content-center align-items-start">
                    <div className="loginLt">
                        <h2>{'Reset Password'}</h2>
                        <h4>{'Create a New Password'}</h4>
                        <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                            <div className="row">{Object.values(mapData(resetPasswordData))}</div>
                            <PrimaryButton type="submit" label={'Change'} />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ForgotPassword
